import a from "react";
import { Text as r } from "../../../Text/Text.js";
import { cls as c } from "../../../../helpers/cls.js";
import { MapPin as l } from "@olxbr/ds-icons";
const n = _ref => {
  let {
    mode: e = "horizontal",
    children: t,
    date: o,
    showLocationMapPin: d
  } = _ref;
  return a.createElement("div", {
    className: c("olx-ad-card__location", "olx-ad-card__location--".concat(e))
  }, !!t && a.createElement("div", {
    className: "olx-ad-card__location-date-container"
  }, d && a.createElement(l, {
    size: 16
  }), a.createElement(r.Caption, {
    tag: "p"
  }, t)), !!o && e === "horizontal" && !!t && a.createElement("span", {
    className: c("olx-ad-card__separator", "olx-ad-card__separator--".concat(e)),
    "aria-hidden": !0
  }, "\xA0|\xA0"), !!o && a.createElement("div", {
    className: "olx-ad-card__location-date-container"
  }, a.createElement(r.Caption, {
    className: "olx-ad-card__date--".concat(e),
    tag: "p",
    "data-testid": "ds-adcard-date"
  }, o)));
};
export { n as Location };